import { clean, splitPoints, type DetailedInfo, type Selection } from './lib';

/**
 * A runner's full form: breeding, the twelve records, and our analysis when it is one of
 * our tips. Shared by the runner card's + and the Field view's expanded row.
 */
export function RunnerDetail({ form, stake, analysis }: { form: DetailedInfo; stake?: string | null; analysis?: Selection['analysis'] }) {
  const d = form;
  const prize = Number(d.horse_prize_money);
  // all twelve records, in the classic card's order; an empty one still shows, faded
  const grid: [string, string][] = (
    [
      ['Career', d.horse_record],
      ['Track', d.horse_record_track],
      ['Distance', d.horse_record_distance],
      ['Trk/Dist', d.horse_record_track_distance],
      ['1st up', d.horse_record_first_up],
      ['2nd up', d.horse_record_second_up],
      ['Firm', d.horse_record_firm],
      ['Good', d.horse_record_good],
      ['Soft', d.horse_record_soft],
      ['Heavy', d.horse_record_heavy],
      ['Synthetic', d.horse_record_synthetic],
      ['Prize', prize > 0 ? `$${prize.toLocaleString('en-AU')}` : null],
    ] as [string, string | null | undefined][]
  ).map(([k, v]) => [k, v || (k === 'Prize' ? '$0' : '0:0-0-0')]);
  const bio = [
    d.horse_age ? `${d.horse_age}yo` : '',
    d.horse_sex ?? '',
    d.horse_sire && d.horse_dam ? `by ${clean(d.horse_sire)} out of ${clean(d.horse_dam)}` : '',
  ].filter(Boolean);
  const pros = splitPoints(analysis?.pros);
  const cons = splitPoints(analysis?.cons);
  const summary = splitPoints(analysis?.summary).join(' ');

  return (
    <div className="ui-rdet">
      <div>
        {bio.join(' · ')}
        {stake && (
          <>
            {bio.length ? ' · ' : ''}Stake: <b>{stake}</b>
          </>
        )}
      </div>
      <div className="kvg">
        {grid.map(([k, v]) => (
          <div key={k} className={v === '0:0-0-0' || v === '$0' ? 'nil' : undefined}>
            <span>{k}</span>
            <b>{v}</b>
          </div>
        ))}
      </div>
      {summary && <p className="sum">{summary}</p>}
      {(pros.length > 0 || cons.length > 0) && (
        <div className="pc">
          {pros.length > 0 && (
            <div className="pro">
              <h5>For</h5>
              <ul>
                {pros.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
            </div>
          )}
          {cons.length > 0 && (
            <div className="con">
              <h5>Against</h5>
              <ul>
                {cons.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
